import React, { Component } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import FooterComponentUpper from "../../../../../../app/components/footer_component/FooterComponentUpper";
import RecommendPost from "../../../../../right_section/RecommendPost";
import RightSideSection from "../../../../../right_section/RightSideSection";
import HeaderBannerSection from "../../../../HeaderBannerSection";
import ScoreCard from "../../scoreCard";
import MCQTestCardCarousel from "../MCQTestCardCarousel";
import QuizeTest from "../quizeTest";
import CardCover from "../../../../../../shared_components/CardCover";
import CustomButton from "../../../../../../shared_components/CustomButton";

class ReactQuizeTest3 extends Component {
  state = {
    isCorrect: false,
    isClicked: false,
    count: 0,
    status: "",
    show: false,
  };
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  counter = (count) => {
    this.setState({ count: this.state.count + 1 });
  };

  showQuizeScore = () => {
    this.setState({ show: true });
  };

  handleShow = () => {
    this.setState({ show: true });
  };

  handleClose = () => {
    this.setState({ show: false });
  };
  render() {
    return (
      <>
        <HeaderBannerSection imgsource="headerdark.jpeg" />

        <div className="container-fluid">
          <div className="row">
            <div className="col-1"></div>
            <div className="col-md-7 ">
              <div className="row">
                <div className="col text-center mt-3 mb-3">
                  <h2>React Quiz Test Advance</h2>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <Link to="/home" className="badge badge-primary mr-1">
                    Home
                  </Link>
                  <Link
                    to="/index_quize_tests"
                    className="badge badge-warning mr-1"
                  >
                    Quize Test
                  </Link>
                  <Link
                    to="/react_quize_tests"
                    className="badge badge-success mr-1"
                  >
                    React Quize
                  </Link>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <QuizeTest
                    quizeNo="1"
                    question="Life cycle methods of a components fall under following categories?"
                    correctAnswer="Mounting, Updating, Unmounting"
                    v1="None of these"
                    v2=" Mounting, Updating"
                    v3="Mounting, Unmounting"
                    v4="Mounting, Updating, Unmounting"
                    counter={this.counter}
                  />

                  <QuizeTest
                    quizeNo="2"
                    question="Which of the following mounting methods are invoked before the component is inserted into DOM?"
                    correctAnswer=""
                    v1="componentWillMount"
                    v2="getInitialState, componentDidMount "
                    v3="getInitialState, componentWillMount"
                    v4="getInitialState
                "
                    counter={this.counter}
                  />

                  <QuizeTest
                    quizeNo="3"
                    question=""
                    correctAnswer=""
                    v1=""
                    v2=""
                    v3=""
                    v4=""
                    counter={this.counter}
                  />

                  <QuizeTest
                    quizeNo="4"
                    question=""
                    correctAnswer=""
                    v1=""
                    v2=""
                    v3=""
                    v4=""
                    counter={this.counter}
                  />
                  <QuizeTest
                    quizeNo="5"
                    question=""
                    correctAnswer=""
                    v1=""
                    v2=""
                    v3="="
                    v4=""
                    counter={this.counter}
                  />
                  <QuizeTest
                    quizeNo="6"
                    question=""
                    correctAnswer=""
                    v1=""
                    v2=""
                    v3=""
                    v4=""
                    counter={this.counter}
                  />

                  <QuizeTest
                    quizeNo="7"
                    question=""
                    correctAnswer=""
                    v1=""
                    v2=""
                    v3=""
                    v4=""
                    counter={this.counter}
                  />

                  <QuizeTest
                    quizeNo="8"
                    question=""
                    correctAnswer=""
                    v1=""
                    v2=""
                    v3=""
                    v4=""
                    counter={this.counter}
                  />

                  <QuizeTest
                    quizeNo="9"
                    question=""
                    correctAnswer=""
                    v1=""
                    v2=""
                    v3=""
                    v4=""
                    counter={this.counter}
                  />

                  <QuizeTest
                    quizeNo="10"
                    question=""
                    correctAnswer=""
                    v1=""
                    v2=""
                    v3=""
                    v4=""
                    counter={this.counter}
                  />
                </div>
              </div>
              <div className="text-center mb-3">
                 <CustomButton buttonName="Show Score" onClick={this.handleShow}/>
              </div>
              <div className="row">
                <div className="col">
                  <h5> For More Quiz Test</h5>
                  <MCQTestCardCarousel />
                </div>
              </div>
            </div>
            <div className="col-md-4  mt-md-4">
              <h4>Recommendation</h4>
              <RecommendPost
                // imgsource='python_mcqs.jpeg'
                cardComponent={
                  <CardCover
                    cardName="Python MCQs Questions"
                    className="py-4"
                    index={0}
                  />
                }
                RecPostHading="Python MCQs Questions"
                link="/index_python_mcqs"
              />
              <RecommendPost
                cardComponent={
                  <CardCover
                    cardName="Java MCQs Questions"
                    className="py-4"
                    index={1}
                  />
                }
                RecPostHading="Java MCQs Questions"
                link="/index_java_mcqs"
              />
              <RecommendPost
                cardComponent={
                  <CardCover
                    cardName="C MCQs Questions"
                    className="py-4"
                    index={2}
                  />
                }
                RecPostHading="C MCQs Questions"
                link="/index_c_mcqs"
              />
              <RightSideSection />
            </div>
          </div>
        </div>
        <ScoreCard
          handleShow={this.handleShow}
          handleClose={this.handleClose}
          show={this.state.show}
          count={this.state.count}
        />
        <div className="container-fluid mt-5">
          <FooterComponentUpper />
        </div>
      </>
    );
  }
}

export default ReactQuizeTest3;
